import { Flame, Trophy } from "lucide-react";

export const StreakCard = ({ streak }) => (
  <div className="card-clay relative overflow-hidden p-6 sm:p-7" data-testid="streak-card">
    <div className="pointer-events-none absolute -right-10 -top-10 h-44 w-44 rounded-full bg-streak/15 blur-2xl" />
    <div className="relative flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-4">
        <div className={`flex h-16 w-16 items-center justify-center rounded-2xl ${streak.current ? "bg-streak" : "bg-stone-200"}`}>
          <Flame className={`h-8 w-8 text-white ${streak.current ? "animate-flicker" : ""}`} />
        </div>
        <div>
          <p className="eyebrow text-streak-ink">Racha diaria</p>
          <p className="font-display text-4xl font-extrabold leading-none text-ink" data-testid="streak-current">
            {streak.current} <span className="text-lg font-bold text-stone-500">{streak.current === 1 ? "día" : "días"}</span>
          </p>
          <p className="mt-1 text-sm text-stone-600" data-testid="streak-message">
            {streak.today_done ? "¡Hoy ya cuenta! Sigue así." : "Haz una acción de tu plan hoy para mantenerla."}
          </p>
        </div>
      </div>
      <div>
        <div className="flex gap-2" data-testid="streak-week">
          {streak.week.map((d) => (
            <div key={d.date} className="flex flex-col items-center gap-1">
              <span className={`flex h-9 w-9 items-center justify-center rounded-full text-xs font-bold transition-colors ${d.done ? "bg-streak text-white" : "bg-stone-100 text-stone-400"}`}>{d.weekday}</span>
            </div>
          ))}
        </div>
        <p className="mt-2 flex items-center gap-1.5 text-xs text-stone-500">
          <Trophy className="h-3.5 w-3.5 text-streak" /> Mejor racha: <strong data-testid="streak-best">{streak.best}</strong> días
        </p>
      </div>
    </div>
    <p className="relative mt-5 text-xs text-stone-500">Cuenta como día cumplido: completar el entreno, marcar 2 comidas, anotar un síntoma o registrar tu peso o importar una actividad.</p>
  </div>
);
